// extracted by mini-css-extract-plugin
export var item = "ProgramItems-module--item--2dcd4";
export var time = "ProgramItems-module--time--ce662";
export var aboutItem = "ProgramItems-module--aboutItem--c99b2";
export var list = "ProgramItems-module--list--5cd72";
export var speaker = "ProgramItems-module--speaker--f2596";
export var speakerPicture = "ProgramItems-module--speakerPicture--ca6ef";
export var speakerImg = "ProgramItems-module--speakerImg--50e0f";
export var speakerName = "ProgramItems-module--speakerName--8dac7";